var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.3571C0 6.42791 6.42791 0 14.3571 0C22.2864 0 28.7143 6.42791 28.7143 14.3571C28.7143 22.2864 22.2864 28.7143 14.3571 28.7143C6.42791 28.7143 0 22.2864 0 14.3571Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0662 22.7184C15.3835 23.2941 13.5646 23.3124 11.8711 22.7705C10.1776 22.2286 8.69679 21.1546 7.64182 19.7029C6.58685 18.2512 6.01207 16.4967 6.00019 14.6918C5.9883 12.887 6.53992 11.1248 7.57568 9.65886C8.61144 8.19293 10.0779 7.09882 11.7642 6.53394C13.4504 5.96907 15.2694 5.96256 16.9595 6.51534C18.6496 7.06813 20.1236 8.15171 21.1695 9.61019C22.2154 11.0687 22.7792 12.8268 22.7799 14.6317C22.7527 15.3236 22.6703 16.012 22.5335 16.6903",
    stroke: "#1E2132"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3673 21.1338C15.7638 21.8309 15.1021 22.4738 14.3896 23.0551",
    stroke: "#1E2132"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3896 6.00391C16.6544 8.01542 18.0557 10.8474 18.2944 13.895C18.3434 14.4482 18.3535 15.0043 18.3247 15.559",
    stroke: "#1E2132"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.39 6.00391C13.1613 7.0927 12.1741 8.4345 11.494 9.94042C10.8138 11.4463 10.4562 13.082 10.4448 14.739C10.4448 20.2971 12.9017 21.9439 14.3799 23.0555",
    stroke: "#1E2132"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08984 10.4297H21.73",
    stroke: "#1E2132"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3896 6V23.0551",
    stroke: "#1E2132"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31934 19.2061H16.0906",
    stroke: "#1E2132"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.7386L22.7799 14.5293",
    stroke: "#1E2132"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5049 24.2151L24 22.6918L21.3001 19.9471L22.8356 18.9487C22.858 18.9352 22.8758 18.9152 22.8867 18.8912C22.8977 18.8672 22.9012 18.8404 22.8968 18.8144C22.8924 18.7884 22.8803 18.7643 22.8622 18.7454C22.844 18.7265 22.8206 18.7136 22.7951 18.7085L17.6349 17.4802C17.6136 17.4758 17.5916 17.4768 17.5708 17.4832C17.5499 17.4896 17.531 17.5011 17.5156 17.5167C17.5002 17.5324 17.4889 17.5516 17.4826 17.5728C17.4764 17.594 17.4754 17.6164 17.4797 17.6381L18.6002 22.9834C18.6055 23.0094 18.6184 23.0332 18.6371 23.0517C18.6558 23.0702 18.6796 23.0827 18.7052 23.0874C18.7309 23.0922 18.7574 23.0891 18.7814 23.0786C18.8054 23.068 18.8257 23.0504 18.8398 23.028L19.805 21.4704L22.5049 24.2151Z",
    stroke: "#1E2132"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWb);
export default __webpack_public_path__ + "static/media/wb.730e88df6bd3408ff16f7bc1b7abc251.svg";
export { ForwardRef as ReactComponent };